import type { ComponentType } from 'react';
import React from 'react';
import { Redirect } from 'react-router-dom';
import { useObservable } from 'react-use-observable';

import eduzzAccountsService from 'v2/services/eduzzAccount';

interface WithPartnerOnlyProps {
  action?: string | string[];
}

const withPartnerOnly =
  <P extends Record<string, unknown>>(Component: ComponentType<P>) =>
  (props: WithPartnerOnlyProps & P) => {
    const [user] = useObservable(() => eduzzAccountsService.getUser(), []);
    if (!user) return null;

    const isPartner = user?.acceptence_terms;
    const hasDocument = user?.document;

    if (isPartner && !hasDocument) {
      return <Redirect to='/producer/profile' />;
    }

    if (!isPartner) {
      return <Redirect to='/producer/shopping' />;
    }

    return <Component {...props} />;
  };

export default withPartnerOnly;
